var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.836 25H65.6026C61.5901 25 58.3359 28.2542 58.3359 32.2667V62.5125H120.836V25Z",
    fill: "#169154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3359 137.725V167.733C58.3359 171.745 61.5901 175 65.5984 175H120.836V137.725H58.3359Z",
    fill: "#18482A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3359 62.5117H120.836V100.02H58.3359V62.5117Z",
    fill: "#0C8045"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3359 100.021H120.836V137.73H58.3359V100.021Z",
    fill: "#17472A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.069 25H120.836V62.5125H183.336V32.2667C183.336 28.2542 180.082 25 176.069 25Z",
    fill: "#29C27F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.836 137.725V175H176.073C180.082 175 183.336 171.745 183.336 167.737V137.729H120.836V137.725Z",
    fill: "#27663F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.836 62.5117H183.336V100.02H120.836V62.5117Z",
    fill: "#19AC65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.836 100.021H183.336V137.73H120.836V100.021Z",
    fill: "#129652"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9932 141.667H23.6682C19.8016 141.667 16.6641 138.53 16.6641 134.663V65.3382C16.6641 61.4715 19.8016 58.334 23.6682 58.334H92.9932C96.8599 58.334 99.9974 61.4715 99.9974 65.3382V134.663C99.9974 138.53 96.8599 141.667 92.9932 141.667Z",
    fill: "#0C7238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8622 79.166H50.8039L58.8706 94.8077L67.3956 79.166H76.6831L63.8872 99.9993L76.9747 120.833H67.1789L58.3872 104.458L49.6331 120.833H39.6914L52.9956 99.9243L40.8622 79.166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelThumbnail);
export default __webpack_public_path__ + "static/media/excel-thumbnail.8b7c5466496a1d27352fb6bca2ee4d49.svg";
export { ForwardRef as ReactComponent };